import { useAuth } from "@/lib/auth-context";
import { PermissaoEnum } from "@workflow/types";

export function usePermissions() {
  const { user } = useAuth();

  const hasPermission = (permissionName: PermissaoEnum): boolean => {
    if (!user || !user.roles) return false;

    const isAdmin = user.roles.some((role) => role.nome === "ADMIN");
    if (isAdmin) return true;

    const userPermissions = user.roles
      .flatMap((role) => role.permissoes || [])
      .map((permissao) => permissao.nome);

    return userPermissions.includes(permissionName);
  };

  const hasAnyPermission = (permissionNames: PermissaoEnum[]): boolean => {
    return permissionNames.some((permission) => hasPermission(permission));
  };

  const hasAllPermissions = (permissionNames: PermissaoEnum[]): boolean => {
    return permissionNames.every((permission) => hasPermission(permission));
  };

  const isAdmin = !!user?.roles?.some((role) => role.nome === "ADMIN");

  return {
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    isAdmin,
  };
}
